import { z } from 'zod';
import { sha256HexSchema } from '../macroPackage/canonicalJson';
import { graphCountSchema, graphIdSchema } from './primitives';

export const definitionPinSchema = z.object({ definitionId: graphIdSchema, definitionDigest: sha256HexSchema }).strict();
export type DefinitionPin = z.infer<typeof definitionPinSchema>;
export const graphLibraryNameSchema = z.string().trim().min(1).max(120);
export const graphLibraryItemSchema = z.object({ documentId: graphIdSchema, name: graphLibraryNameSchema,
  updatedAtUnixMs: graphCountSchema, revision: graphCountSchema, macroCount: graphCountSchema }).strict();
export type GraphLibraryItem = z.infer<typeof graphLibraryItemSchema>;
export const graphLibraryDefinitionSchema = z.object({ pin: definitionPinSchema, name: z.string().min(1).max(80),
  revision: graphCountSchema, gameId: z.string().min(1).nullable(), placementCount: graphCountSchema }).strict();
export type GraphLibraryDefinition = z.infer<typeof graphLibraryDefinitionSchema>;
export const graphLibraryCreateSchema = z.object({ name: graphLibraryNameSchema }).strict();
export const graphLibraryRenameSchema = graphLibraryCreateSchema.extend({ expectedRevision: graphCountSchema });
export const graphLibraryDuplicateSchema = graphLibraryRenameSchema;
export const graphLibraryItemReplySchema = z.object({ item: graphLibraryItemSchema }).strict();
export const graphLibraryListReplySchema = z.object({ items: z.array(graphLibraryItemSchema) }).strict().superRefine((value, context) => {
  if (new Set(value.items.map(item => item.documentId)).size !== value.items.length) context.addIssue({
    code: z.ZodIssueCode.custom, message: 'Library documents must be unique' });
});
export const graphLibraryConflictSchema = z.object({ error: z.literal('graph_library_conflict'), revision: graphCountSchema }).strict();
